import { render, staticRenderFns } from "./MainEmbed.vue?vue&type=template&id=592d45fb&scoped=true&"
import script from "./MainEmbed.vue?vue&type=script&lang=ts&"
export * from "./MainEmbed.vue?vue&type=script&lang=ts&"
import style0 from "./MainEmbed.vue?vue&type=style&index=0&id=592d45fb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d45fb",
  null
  
)

export default component.exports